import { api } from '@cwd/lib/main';

export interface ClientCompany {
    ClientCompanyId: string;
    Name: string;
    BillingName: string;
    BillingAttention: string;
    BillingRecipientName: string;
    BillingAddress: string;
    BillingEmail: string;
    IsEuCompany: boolean;
    VatNumber: string;
    Contact: string;
    Phone: string;
    Email: string;
    Url: string;
    BusinessId: string;
    EInvoiceAddress: string;
    InvoicingInstructions: string;
    BillingAddress1: string;
    BillingAddress2: string;
    BillingZipCode: string;
    BillingCity: string;
    BillingCountry: string;
}

export async function getCurrentClientCompany(): Promise<ClientCompany> {
    return api.get('/ClientCompanies/Current');
}

export async function saveCurrentClientCompany(clientCompany: ClientCompany): Promise<ClientCompany> {
    return api.post('/ClientCompanies/Current', clientCompany);
}
